<div class="modal" id="tourismMapPeopleModal" tabindex="-1">
	<!-- <div class="modal-dialog modal-xl modal-dialog-centered"> -->
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<div class="row" style="width: 100%">
					<div class="col-6">
						<h3 class="row">
							<div class="col-auto">
								{{ city?.name }}
							</div>
							<div class="col text-end">
								<span class="btn btn-primary me-4" (click)="driveThru()" *ngIf="editable">
									Przejazd przez
									<i class="far fa-arrow-alt-circle-right"></i>
								</span>
								<span
									class="btn btn-primary"
									*ngIf="editable && city?.reservations.length"
									(click)="getAll()"
								>
									Zabierz wszystkich
									<i class="fas fa-angle-double-right"></i>
								</span>
							</div>
						</h3>
					</div>
					<div class="col-6">
						<h3 class="row">
							<div class="col">
								<button
									type="button"
									class="btn btn-primary"
									*ngIf="editable && vehicleTable.length > 0"
									(click)="putAll()"
								>
									<i class="fas fa-angle-double-left"></i>
									Zostaw wszystkich
								</button>
							</div>

							<div class="col text-end">
								<span class="btn btn-danger btn-lg">{{ vehicle?.name }}</span>
							</div>
						</h3>
					</div>
				</div>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-6">
						<table class="table table-bordered align-middle" *ngIf="city?.reservations.length > 0">
							<thead>
								<tr>
									<th>Rezerwacja</th>
									<th>Osób</th>
									<th>Opcja</th>
									<th>Cel</th>
									<th>Zabierz</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let reservation of city.reservations">
									<td *ngIf="!reservation?.used">
										{{ reservation.number }}
									</td>
									<td *ngIf="!reservation?.used">
										{{ reservation.people }}
									</td>
									<td *ngIf="!reservation?.used">
										<span *ngIf="reservation.option">Opcja</span>
									</td>
									<td *ngIf="!reservation?.used">
										{{ reservation.destinationName }}
									</td>
									<td *ngIf="editable && !reservation?.used" class="text-center">
										<button type="button" class="btn btn-primary" (click)="getPeople(reservation)">
											<i class="fas fa-chevron-right"></i>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-6">
						<table class="table table-bordered align-middle" *ngIf="vehicleTable.length > 0">
							<thead>
								<tr>
									<th>Zostaw</th>
									<th></th>
									<th>Miasto</th>
									<th>Rezerwacja</th>
									<th>Osób</th>
									<th>Opcja</th>
									<th>Cel</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of vehicleTable; index as vehicleTableIndex">
									<td class="text-center">
										<button
											type="button"
											class="btn btn-primary"
											(click)="putPeople(item)"
											*ngIf="
												editable &&
												item.action &&
												item.action.action === 'get' &&
												!item?.action?.left
											"
										>
											<i class="fas fa-chevron-left"></i>
										</button>
									</td>
									<td>
										<i
											class="fas fa-sign-out-alt fa-rotate-270"
											*ngIf="item?.action?.action === 'put'"
										></i>
										<i
											class="fas fa-sign-in-alt fa-rotate-90"
											*ngIf="item?.action?.action === 'get'"
										></i>
									</td>
									<td>
										<span *ngIf="item?.action?.reservation?.originCity !== item.city">
											{{ item?.action?.reservation?.originCity.name }}
											<i class="fas fa-arrow-right"></i>
										</span>
										{{ item.city.name }}
									</td>
									<td>
										{{ item?.action?.reservation?.number }}
									</td>
									<td>
										{{ item?.action?.reservation?.people }}
									</td>
									<td>
										<span *ngIf="item?.action?.reservation?.option">Opcja</span>
									</td>
									<td>
										{{ item?.action?.reservation?.destinationName }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="close()">Zamknij</button>
			</div>
		</div>
	</div>
</div>
